<template>
  <v-dialog v-model="is_ResultDetailModal" max-width="400px">
    <v-card>
      <v-card-title>발송 결과 상세</v-card-title>
      <v-divider></v-divider>
      <v-card-text class="pb-7 pt-3">
        <v-card-subtitle class="font-weight-bold pl-0 pb-0 black--text mb-1">발송 구분/일시</v-card-subtitle>
        <div class="caption text-truncate">
          {{ send_type }} <br />
          {{ send_date }}
        </div>
        <v-card-subtitle class="font-weight-bold pl-0 pb-0 black--text mb-1 mt-5">수신자 정보</v-card-subtitle>
        <div class="caption text-truncate">
          <span v-html="getUserInfo()"></span> <br />
          {{ receiver_info }}
        </div>
        <v-card-subtitle class="font-weight-bold pl-0 pb-0 black--text mb-1 mt-5">발송 결과</v-card-subtitle>
        <div class="caption text-truncate">
          {{ result_type }}
        </div>
        <v-card-subtitle class="font-weight-bold pl-0 pb-0 black--text mb-1 mt-5">발송 메시지</v-card-subtitle>
        <div class="caption text-truncate">
          {{ msg_title }}
        </div>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="is_ResultDetailModal = false">닫기</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Filters from "@/libs/authservice/filters.js";
import CommonMixin from "@/mixins/CommonMixin.js";
import M from "@/libs/mapping.js";
export default {
  data() {
    return {
      is_ResultDetailModal: false,
      msg_id: null,
      send_date: null,
      send_type: null,
      user_id: null,
      receiver_info: null,
      result_type: null,
      msg_type: null,
      msg_title: null,
    };
  },
  created: function() {
    // API Call to get data
    this.msg_id = 1;
    this.send_date = "2021-07-01 12:00:00";
    this.send_type = "SMS";
    this.receiver_info = "010-1234-5678";
    this.result_type = "발송성공";
    this.msg_type = "buyed_confirm";
  },
  mixins: [CommonMixin],
  methods: {
    convertText: function() {
      return Filters.msgTypeText(this.msg_type).replace(/<br\s*\/?>/g, "");
    },
    getUserInfo: function() {
      const admin_url = this.moveEcUserPage(this.user_id);
      return this.msg_type === "lost_3rd_verify_admin"
        ? "관리자"
        : this.user_id
        ? `<a href="${admin_url}" target="_blank">${this.user_id}</a>`
        : "비회원";
    },
    openResultDetailModal(msg_id) {
      // API Call Msg Detail
      this.msg_id = msg_id;
      this.is_ResultDetailModal = true;
      this.getSendResultDetail();
    },
    getSendResultDetail: async function() {
      // API Call to get data
      try {
        const res = await M.api(M.entry("/get/message/send_history_detail", this.msg_id));

        this.send_date = res.send_date;
        this.send_type = res.send_type;
        this.receiver_info = res.receiver_info;
        this.result_type = res.send_status === "success" ? "발송성공" : "발송실패";
        this.msg_type = res.msg_type;
        this.msg_title = this.convertText();
        this.user_id = res.receiver_id;
      } catch (error) {
        console.error(error);
      }
    },
  },
  filters: Filters,
};
</script>
